import update from 'immutability-helper';
import * as types from './types';
import { initialFilter, initialWidgets, initialMetric } from './helper';
import { DEFAULT_FILTER } from '@src/utils/kpi';

const initialState = {
  // to set interval, load persisted data if any

  initializing: true,
  // in the order the widgets are to be displayed (order = index)
  widgets: initialWidgets,
  selectedKPIMetric: initialMetric,
  interval: {
    from: Date.now(),
    shortcut: 'Last 6 hours',
    to: Date.now(),
  },
  filter: initialFilter,
  selectedKPIConfig: null,
};

const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.UPDATE] = (state, action) => {
  const { persistedState } = action;
  return update(state, {
    $merge: {
      ...persistedState,
    },
  });
};

switchMap[types.SET_SELECTED_KPI_CONFIG] = (state, action) =>
  update(state, {
    selectedKPIConfig: { $set: action.selectedKPI },
  });

switchMap[types.SET_SELECTED_METRIC] = (state, action) =>
  update(state, {
    widgets: {
      [action.widgetIndex]: {
        config: {
          metric: { $set: action.metricName },
        },
      },
    },
  });

switchMap[types.SET_SPI_THRESHOLD] = (state, action) =>
  update(state, {
    widgets: {
      [action.widgetIndex]: {
        config: {
          thresholdConfig: { $set: action.config },
        },
      },
    },
  });

switchMap[types.SET_SELECTED_DIMENSION] = (state, action) =>
  update(state, {
    widgets: {
      [action.widgetIndex]: {
        config: {
          dimensions: {
            [action.dimensionIndex]: {
              $set: action.dimension,
            },
          },
        },
      },
    },
  });

switchMap[types.SWAP_SELECTED_DIMENSION] = (state, action) =>
  update(state, {
    widgets: {
      [action.widgetIndex]: {
        config: {
          dimensions: {
            [action.dimensionIndex]: {
              $set: action.dimension,
            },
            [action.swapIndex]: {
              $set: action.swapDimension,
            },
          },
        },
      },
    },
  });

switchMap[types.SET_DIMENSION_UNIT] = (state, action) =>
  update(state, {
    widgets: {
      [action.widgetIndex]: {
        config: {
          unit: { $set: action.unit },
        },
      },
    },
  });

switchMap[types.SET_SELECTED_KPI] = (state, action) =>
  update(state, {
    selectedKPIMetric: { $set: action.selectedKPIMetric },
  });

switchMap[types.APPLY_FILTER] = (state, action) =>
  update(state, {
    filter: { appliedFilters: { $set: [action.filter] } },
  });

switchMap[types.SET_INTERVAL] = (state, action) =>
  update(state, {
    interval: { $set: action.interval },
  });

switchMap[types.RESET_BREADCRUMB] = (state) =>
  update(state, {
    filter: { breadcrumb: { $set: [DEFAULT_FILTER] } },
  });

switchMap[types.PUSH_BREADCRUMB] = (state, action) =>
  update(state, {
    filter: { breadcrumb: { $push: [action.filter] } },
  });

switchMap[types.POP_BREADCRUMB] = (state, action) =>
  update(state, {
    filter: { breadcrumb: { $splice: [[action.index + 1]] } },
  });

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
